// extracted by mini-css-extract-plugin
export default {"container":"CardDrag_container__OoEMY","images":"CardDrag_images__YjvUP","fadeIn":"CardDrag_fadeIn__BenH2","fadeOut":"CardDrag_fadeOut__Monyf"};